var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircleWhite = function SvgPlayCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffffff",
    fillRule: "evenodd",
    d: "M20.5 3.49c-9.389 0-17 7.611-17 17 0 9.39 7.611 17 17 17s17-7.61 17-17c0-9.389-7.611-17-17-17m-20 17c0-11.045 8.954-20 20-20s20 8.955 20 20-8.954 20-20 20-20-8.954-20-20",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffffff",
    d: "M16.5 26.098V14.882a1 1 0 0 1 1.563-.826l8.225 5.608a1 1 0 0 1 0 1.652l-8.225 5.608a1 1 0 0 1-1.563-.826"
  })));
};
export default SvgPlayCircleWhite;